import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Article } from "src/app/common/models/article.model";
import { SearchResult } from "src/app/common/models/search-result.model";
import { AbstractService } from "src/app/common/services/abstract.service";
import { AgencyNews } from "src/app/modules/agency-news/models/agency-news.model";
import { AudiovisualMedia } from "src/app/modules/audiovisual-media/models/audiovisual-media.model";
import { InstagramPost } from "src/app/modules/instagram/models/instagram-post.model";
import { Speech2Text } from "src/app/modules/speech2text/models/speech2text.model";

@Injectable({
  providedIn: "root",
})
export class SearchService extends AbstractService {
  protected baseUrl = "/api/internal/search";
  private readonly httpClient = inject(HttpClient);

  async search(params: HttpParams): Promise<SearchResult[] | null> {
    return await this.cancelPrevious("search", this.httpClient.get<SearchResult[]>(this.baseUrl, { params }));
  }

  async getArticle(result: SearchResult): Promise<Article> {
    return await firstValueFrom(this.httpClient.get<Article>(`/api/internal/articles/${result.id}/preview`));
  }

  async getSpeech2text(result: SearchResult): Promise<Speech2Text> {
    if (result.type === "SPEECH2TEXT_AUDIO") {
      return await firstValueFrom(this.httpClient.get<Speech2Text>(`/api/internal/audiopodcast/${result.id}`));
    }
    return await firstValueFrom(this.httpClient.get<Speech2Text>(`/api/internal/playrts/${result.id}`));
  }

  async getAudiovisualMedia(result: SearchResult): Promise<AudiovisualMedia> {
    return await firstValueFrom(this.httpClient.get<AudiovisualMedia>(`/api/internal/audiovisual-media/${result.id}`));
  }

  async getInstagram(result: SearchResult): Promise<InstagramPost> {
    return await firstValueFrom(this.httpClient.get<InstagramPost>(`/api/internal/instagram/${result.id}`));
  }

  async getAgencyNews(result: SearchResult): Promise<AgencyNews> {
    return await firstValueFrom(this.httpClient.get<AgencyNews>(`/api/internal/agency-news/${result.id}/preview`));
  }
}
